"use client";

import type { ReactNode } from "react";
import type { FallbackProps } from "react-error-boundary";
import { Alert, AlertTitle } from "../alert/alert";
import { Button } from "../button";
interface Props extends FallbackProps {
  children?: ReactNode;
}
export const ErrorFallback: React.FunctionComponent<Props> = ({
  error,
  resetErrorBoundary
}) => {
  return <div className="mx-auto flex h-full max-w-[300px] flex-col py-8" role="alert" data-sentry-component="ErrorFallback" data-sentry-source-file="error-fallback.tsx">
      <h1 className="mb-6 text-2xl">Something went wrong</h1>

      <Alert variant="destructive" className="mb-8 text-left" data-sentry-element="Alert" data-sentry-source-file="error-fallback.tsx">
        <AlertTitle data-sentry-element="AlertTitle" data-sentry-source-file="error-fallback.tsx">Error</AlertTitle>
        {error.message}
      </Alert>

      <Button variant="default" type="button" onClick={resetErrorBoundary} data-sentry-element="Button" data-sentry-source-file="error-fallback.tsx">
        Try again
      </Button>
    </div>;
};